/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-09-17 11:32:30
 * @LastEditors: linxi
 * @LastEditTime: 2023-07-04 14:35:57
 */
import { Button, Col, notification, Row, Space } from 'antd'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import { selectTwoMenus,selectMenus } from '../../layouts/layoutSlice'
import { ThemeContext } from '../../theme/ThemeContext'
import { MembersManagementPage } from '../membersManagement/membersManagementPage'
import { OutPatientList } from '../outpatientList/outpatientList'
import { Patients, PatientsRef } from '../patient/list/Patients'
import { PatientLable } from '../patient/patientLable/patientlable'
import { ExportOutlined } from '../../compnents/icons/Icons'
import { selectChainId, selectChainType, selectRole, selectTenantId } from '../../app/applicationSlice'
import styles from './OutpatientStatistics.module.css'
import { selectExportloading } from '../patient/list/patientListSlice'
import { ChianPatients } from '../patient/list/ChainPatients/chainPatients'
import { SettingOutlined } from '@ant-design/icons'

export const OutpatientStatistics = (): ReactElement => {
  const theme = useContext(ThemeContext)
  
  const role = useSelector(selectRole)

  const exportRef = useRef<PatientsRef>(null)

  const exRef = useRef<any>(null)

  const history = useHistory()
  const location: any = useLocation()

  const tenantId = useSelector(selectTenantId)
    
  const chainId = useSelector(selectChainId)
  
  const chainType = useSelector(selectChainType) //1上药 2传统连锁 3中医连锁
  
  const [selectedTab, setSelectedTab] = useState('0')

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname) || '{}'
  )

  useEffect(() => {
    setSelectedTab(location?.state?.station || storageParams.state || '0')
  }, [location?.state])

 const exportLoading = useSelector(selectExportloading)

 const twoMenus = useSelector(selectTwoMenus)

  const menuList = twoMenus?.filter((v) => {
    return v?.name == '患者管理'
  })?.[0]

  const getKeys = (i: string) => {
    switch (i) {
      case '患者管理':
        return '0'
      case '患者标签管理':
        return '1'
      case '会员管理':
        return '2'
      case '门诊日志':
        return '3'
      default:
        return '-'
    }
  }

  return (
    <Col
      style={{
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        height: '100%',
        overflowY: 'hidden',
      }}
    >
      <TabBar
        style={{ margin: '10px 20px' }}
        activeKey={selectedTab}
        destroyInactiveTabPane
        onChange={(v) => setSelectedTab(v)}
      >
        {menuList?.subMenus?.map((v: any) => {
          return (
            <>
              <TabPane key={getKeys(v?.name)} tab={v?.name}>
                {v?.name == '患者管理' ? (
                   tenantId == chainId && chainType == 3 ? <>
                    <ChianPatients state={selectedTab}/>
                   </> : 
                  <Patients state={selectedTab} ref={exportRef}/>
                ) : v?.name == '患者标签管理' ? (
                  <PatientLable state={selectedTab} />
                ) : v?.name == '会员管理' ? (
                  <MembersManagementPage state={selectedTab} />
                ) : v?.name == '门诊日志' ? (
                  <Col
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      backgroundColor: theme.pn,
                      borderRadius: 10,
                      margin: '10px 0',
                      height: 'calc(100% - 10px)',
                    }}
                  >
                    <Col
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: theme.pn,
                        borderRadius: 10,
                        height: 'calc(100% - 10px)',
                      }}
                    >
                      <OutPatientList ref={exRef} parentId={v?.id} state={3}/>
                    </Col>
                  </Col>
                )  : (
                  <></>
                )}
              </TabPane>
            </>
          )
        })}
      </TabBar>
      {selectedTab === '2' && (
        <Row
          style={{
            position: 'absolute',
            height: '2.5rem',
            right: 20,
            top: 10,
            fontSize: '1rem',
            padding: '0 20px',
            color: '#999999'
          }}
          align='middle'
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <SettingOutlined
              style={{
                fontSize: '20px',
                color: '#999999'
              }}
            />
            <a
            type='text'
            style={{
              marginLeft: '6px',
              fontSize: '16px',
              color: '#101010',
              cursor: 'pointer',
            }}
            onClick={() => history.push('/memberBenefits')}
          >
            会员权益
          </a>
          </div>
        </Row>
      )}
    </Col>
  )
}
